var _Decorator, _ChevronDown, _Decorator2;
import * as React from 'react';
import clsx from 'clsx';
import { Spinner } from '@ovpn-ui/core';
import { ChevronDown } from '@ovpn-ui/icons';
import Accordion from './Accordion';
import FlyoutMenu from './FlyoutMenu';
import { Wrapper, Link, Title, Icon, SubLink, ChevronWrapper, SubLinkWrapper, Decorator } from './SidebarMenuItem.styles';
import { isMainLinkActive, isActive, getMenuNavigationProps } from './SidebarMenuItem.utils';
import { getMenuItemText } from './utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function SidebarMenuItem(props) {
  const {
    link,
    open = false,
    onClick,
    pathname,
    enableIosTap
  } = props;
  const hasChildren = !!link.children;
  const isHeaderActive = isMainLinkActive(link, pathname);
  const clickEventName = enableIosTap ? 'onMouseUp' : 'onClick';
  const prevPathname = React.useRef(pathname);
  const [expanded, toggleExpand] = React.useState(link.defaultExpanded || hasChildren && isHeaderActive);
  const handleExpandClick = React.useCallback(() => {
    if ((open || !expanded) && !link.disableExpand) {
      toggleExpand(!expanded);
    }
  }, [expanded, open, link.disableExpand]);
  const {
    className: classNameLinkProp = '',
    ...headerNavProps
  } = hasChildren ? {
    as: 'div',
    [clickEventName]: handleExpandClick
  } : getMenuNavigationProps({
    pathname,
    link,
    enableIosTap,
    onClick
  });
  React.useEffect(() => {
    if (prevPathname.current !== pathname) {
      prevPathname.current = pathname;

      // Force expand nested menu on navigate
      if (!expanded && hasChildren && isHeaderActive) {
        toggleExpand(true);
      }
    }
  }, [expanded, isHeaderActive, hasChildren, pathname]);
  const expandedState = clsx('ovpn-sidebar-link', classNameLinkProp, {
    expanded: hasChildren && expanded && open,
    collapsed: hasChildren && !expanded && open
  });
  const linkButton = /*#__PURE__*/_jsxs(Link, {
    $active: isHeaderActive,
    $expanded: expanded && open,
    $open: open,
    $disableExpand: link.disableExpand,
    ...headerNavProps,
    className: expandedState,
    children: [/*#__PURE__*/_jsx(Icon, {
      open: open,
      className: "ovpn-sidebar-link-icon",
      children: link.icon
    }), /*#__PURE__*/_jsx(Title, {
      $open: open,
      className: "ovpn-sidebar-link-name",
      children: link.label
    }), link.$isLoading ? _Decorator || (_Decorator = /*#__PURE__*/_jsx(Decorator, {
      className: "ovpn-sidebar-sublink-decorator",
      children: /*#__PURE__*/_jsx(Spinner, {})
    })) : link.decorator && /*#__PURE__*/_jsx(Decorator, {
      className: "ovpn-sidebar-sublink-decorator",
      children: link.decorator
    }), hasChildren && !link.disableExpand && /*#__PURE__*/_jsx(ChevronWrapper, {
      $on: expanded,
      $open: open,
      children: _ChevronDown || (_ChevronDown = /*#__PURE__*/_jsx(ChevronDown, {}))
    }), !open && /*#__PURE__*/_jsx(FlyoutMenu, {
      title: typeof link.label === 'string' ? link.label : getMenuItemText(link.label),
      links: link.children,
      pathname: pathname,
      onLinkClick: onClick
    })]
  });
  if (hasChildren) {
    var _link$children;
    return /*#__PURE__*/_jsx(Wrapper, {
      children: /*#__PURE__*/_jsxs(Accordion, {
        expanded: open && (link.disableExpand || expanded),
        children: [linkButton, /*#__PURE__*/_jsx(SubLinkWrapper, {
          $open: open,
          className: "ovpn-sidebar-sublinks",
          children: (_link$children = link.children) == null ? void 0 : _link$children.map(childLink => {
            const subLinkProps = getMenuNavigationProps({
              pathname,
              link: childLink,
              enableIosTap,
              onClick
            });
            return /*#__PURE__*/_jsxs(SubLink, {
              $open: open,
              $active: isActive(childLink, pathname),
              [clickEventName]: e => onClick == null ? void 0 : onClick(e, subLinkProps),
              ...subLinkProps,
              className: clsx('ovpn-sidebar-sublink', subLinkProps == null ? void 0 : subLinkProps.className),
              children: [childLink.label, childLink.$isLoading ? _Decorator2 || (_Decorator2 = /*#__PURE__*/_jsx(Decorator, {
                className: "ovpn-sidebar-sublink-decorator",
                children: /*#__PURE__*/_jsx(Spinner, {})
              })) : childLink.decorator && /*#__PURE__*/_jsx(Decorator, {
                className: "ovpn-sidebar-sublink-decorator",
                children: childLink.decorator
              })]
            }, `${childLink.label}-${childLink.to || ''}-${childLink.href || ''}`);
          })
        })]
      })
    });
  }
  return /*#__PURE__*/_jsx(Wrapper, {
    children: linkButton
  });
}
export default SidebarMenuItem;